<template>
  <main
    id="page"
    :class="['page-view', currentPage]"
    :style="{
      '--page-color': `var(--${currentPage})`,
      '--page-gradient': `var(--diag-gradient-${currentPage})`,
    }"
  >
    <template v-if="currentPage">
      <component
        v-for="component of pages[currentPage]"
        :key="currentPage + component.id"
        :is="pageComponents[component.component]"
        :currentPage="currentPage"
        :id="component.id"
        v-bind="component.content"
      />
    </template>

    <NavFooter
      v-if="showFooter"
      :currentPage="currentPage"
      :allLinks="pageLinks"
    />
  </main>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import CTASection from "../components/sections/CTASection.vue";
import HubMultimedialeSection from "../components/sections/HubMultimedialeSection.vue";
import HubMultimedialeHero from "../components/general/HubMultimedialeHero.vue";
import PageHero from "../components/sections/PageHero.vue";
import VideoSection from "../components/sections/VideoSection.vue";
import CardSlider from "../components/sections/CardSlider.vue";
import VideoSlider from "../components/sections/VideoSlider.vue";
import InterviewSlider from "../components/sections/InterviewSlider.vue";
import CountrySlider from "../components/sections/CountrySlider.vue";
import HomeHero from "../components/sections/HomeHero.vue";
import InterviewSection from "../components/sections/InterviewSection.vue";
import TextSection from "../components/sections/TextSection.vue";
import TextSectionGrey from "../components/sections/TextSectionGrey.vue";
import TextSectionWhite from "../components/sections/TextSectionWhite.vue";
import TextSectionOverflow from "../components/sections/TextSectionOverflow.vue";
import ImageSection from "../components/sections/ImageSection.vue";
import BGVideoSection from "../components/sections/BGVideoSection.vue";
import KPISection from "../components/sections/KPISection.vue";
import PodcastSection from "../components/sections/PodcastSection.vue";

import ChartRoadTo2050 from "../components/charts/info-road-2050/ChartRoadTo2050.vue";
import MapSection from "../components/charts/map/MapSection.vue";
import StrategyInfograph from "../components/charts/strategy-infograph/StrategyInfograph.vue";
import NavFooter from "../components/general/NavFooter.vue";

const route = useRoute();
const { tm } = useI18n();

const pageComponents = {
  CTASection,
  HubMultimedialeSection,
  PageHero,
  VideoSection,
  CardSlider,
  VideoSlider,
  InterviewSlider,
  CountrySlider,
  HomeHero,
  InterviewSection,
  TextSection,
  TextSectionGrey,
  TextSectionOverflow,
  TextSectionWhite,
  ImageSection,
  BGVideoSection,
  KPISection,
  ChartRoadTo2050,
  HubMultimedialeHero,
  PodcastSection,
  MapSection,
  StrategyInfograph,
};

const currentPage = ref("");

const pages = computed(() => tm("pages"));
const pageLinks = computed(() => Object.keys(pages.value));

const showFooter = computed(
  () => !["home", "download-multimedia"].includes(route.params.page)
);

onMounted(() => {
  
  currentPage.value = route.params.page;
});

watch(
  () => route.params.page,
  () => {
    currentPage.value = route.params.page;
  }
);

</script>

<style lang="scss" scoped>
// 
</style>
